$eve_app_page_themer_colors $mol_row
	color_back? \oklch(20% .01 240deg)
	color_card? \oklch(30% .05 240deg / .25)
	color_field? \oklch(15% 0 240deg / .25)
	color_hover? \oklch(70% 0 240deg / .1)
	color_text? \oklch(80% 0 240deg)
	color_shade? \oklch(60% 0 240deg)
	color_line? \oklch(60% 0 240deg / .25)
	color_focus? \oklch(80% .2 60deg)
	color_control? \oklch(70% .1 240deg)
	color_current? \oklch(70% .2 150deg)
	color_special? \oklch(70% .2 330deg)
	sub /
		<= Controls $mol_scroll
			sub /
				<= Controls_inner $mol_list
					rows /
						<= Controls_title $mol_view
							sub / <= Controls_title_text $mol_dimmer
						<= Backgrouneve_section $mol_list
							rows /
								<= Backgrouneve_title $mol_view
									sub / <= Backgrouneve_title_text $mol_dimmer
										haystack \Backgrounds
								<= Back_field $mol_form_field
									name \Background
									Content <= Back_color $eve_app_color
										value? <=> color_back? \oklch(20% .01 240deg)
								<= Card_field $mol_form_field
									name \Card
									Content <= Card_color $eve_app_color
										value? <=> color_card? \oklch(30% .05 240deg / .25)
								<= Field_field $mol_form_field
									name \Field
									Content <= Field_color $eve_app_color
										value? <=> color_field? \oklch(15% 0 240deg / .25)
								<= Hover_field $mol_form_field
									name \Hover
									Content <= Hover_color $eve_app_color
										value? <=> color_hover? \oklch(70% 0 240deg / .1)
						<= Text_section $mol_list
							rows /
								<= Text_title $mol_view
									sub / <= Text_title_text $mol_dimmer
										haystack \Text Colors
								<= Text_field $mol_form_field
									name \Text
									Content <= Text_color $eve_app_color
										value? <=> color_text? \oklch(80% 0 240deg)
								<= Shade_field $mol_form_field
									name \Shade
									Content <= Shade_color $eve_app_color
										value? <=> color_shade? \oklch(60% 0 240deg)
								<= Line_field $mol_form_field
									name \Line
									Content <= Line_color $eve_app_color
										value? <=> color_line? \oklch(60% 0 240deg / .25)
								<= Focus_field $mol_form_field
									name \Focus
									Content <= Focus_color $eve_app_color
										value? <=> color_focus? \oklch(80% .2 60deg)
						<= Controls_section $mol_list
							rows /
								<= Controls_section_title $mol_view
									sub / <= Controls_section_title_text $mol_dimmer
										haystack \Control Colors
								<= Control_field $mol_form_field
									name \Control
									Content <= Control_color $eve_app_color
										value? <=> color_control? \oklch(70% .1 240deg)
								<= Current_field $mol_form_field
									name \Current
									Content <= Current_color $eve_app_color
										value? <=> color_current? \oklch(70% .2 150deg)
								<= Special_field $mol_form_field
									name \Special
									Content <= Special_color $eve_app_color
										value? <=> color_special? \oklch(70% .2 330deg)
		<= Preview $mol_scroll
			sub /
				<= Preview_inner $mol_view
					style *
						--mol_theme_back <= color_back
						--mol_theme_card <= color_card
						--mol_theme_field <= color_field
						--mol_theme_hover <= color_hover
						--mol_theme_text <= color_text
						--mol_theme_shade <= color_shade
						--mol_theme_line <= color_line
						--mol_theme_focus <= color_focus
						--mol_theme_control <= color_control
						--mol_theme_current <= color_current
						--mol_theme_special <= color_special
					sub /
						<= Demo_site $eve_app_demo
